import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { actionCreators } from '@/store/PersonalAccessTokens'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { BsrsGrid, DateCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { WhiteBox } from '@/components/Layout'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import { deleteTokenColumnProps } from './gridActions'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'

@localized()
class PersonalAccessTokens extends React.Component {
  componentWillMount () {
    this.props.getAllTokens()
  }
  isLoading () {
    const { fetching, generating, deleting } = this.props
    return fetching || generating || deleting
  }
  openInputPatNameDialog () {
    const { openDialog, localize, generatePersonalAccessToken } = this.props
    openDialog({
      dialogType: dialogTypes.inputPatTokenName,
      onAction: ({ name, validityInDays }) => openTwoFactorDialog(() => generatePersonalAccessToken(name, validityInDays)),
      localize
    })
  }
  render () {
    if (this.isLoading()) { return <LoadingIndicator /> }

    const { tokens, localize, deleteToken } = this.props
    return (
      <WhiteBox
        className='RsaKeysManagement'
        header={<Resx name='Security.PersonalAccessTokens' />}
        buttons={<Button
          onClick={() => this.openInputPatNameDialog()}
          color='primary'
          size='sm'
          className='generate-button pull-right' icon='chip'> <span>{localize('Security.Generate')}</span></Button>}>
        <BsrsGrid items={tokens} simpleView>
          <Column field='id' title={localize('Common.Id')} width='150px' />
          <Column field='name' title={localize('Common.Name')} />
          <Column field='validTo' title={localize('Security.ValidTo')} cell={DateCell} width='150px' />
          <Column {...deleteTokenColumnProps({ deleteToken, localize })} width='150px' />
        </BsrsGrid>
      </WhiteBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state.personalAccessTokens,
  ...ownProps
})

const mapDispatchToProps = {
  getAllTokens: actionCreators.getAll,
  generatePersonalAccessToken: actionCreators.generatePersonalAccessToken,
  deleteToken: actionCreators.deletePersonalAccessToken,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalAccessTokens)



// WEBPACK FOOTER //
// ./src/components/userProfile/personalAccessTokens/index.js